// Which simple emails an active automation takes the place of, by trigger key.
// The rule itself lives in the lambdas: wherever one calls
// util.hasActiveEmailAutomation(con, triggerKey, groupId) and skips the simple
// email when it is true. This map mirrors those call sites so the console can
// say what is replaced; update it when a lambda's gate changes.
//
// emails: automated_email_configurations.email_type values (Simple Emails rows).
// staff: the staff copy of that email is replaced too. Left false where the
// lambdas disagree by payment method (transaction_created).
//
// Not listed on purpose: reminder, follow_up, surveys and gift_cards (delivery)
// are never replaced, and booking_requested has no Simple Emails row of its own.
export const AUTOMATION_REPLACES_SIMPLE_EMAILS = {
  booking_created_customer: { emails: ['confirmation'], staff: true },
  transaction_created: { emails: ['confirmation'], staff: false },
  booking_created_internal: { emails: ['confirmation', 'updated_booking'], staff: true },
  booking_request_approved: { emails: ['confirmation'], staff: false },
  booking_reactivated: { emails: ['confirmation'], staff: true },
  payment_success: { emails: ['updated_booking'], staff: true },
  booking_datetime_updated: { emails: ['updated_booking'], staff: true },
  booking_rescheduled_slot: { emails: ['updated_booking'], staff: true },
  booking_group_size_updated: { emails: ['updated_booking'], staff: true },
  transaction_customer_updated: { emails: ['updated_booking'], staff: true },
  booking_cancelled: { emails: ['cancelled_booking'], staff: true },
  transaction_cancelled: { emails: ['cancelled_transaction'], staff: true },
  booking_request_denied: { emails: ['cancelled_transaction'], staff: true },
  gift_card_purchased_customer: { emails: ['gift_card_confirmation'], staff: false },
  gift_card_purchased_internal: { emails: ['gift_card_confirmation'], staff: false },
  payment_request_sent: { emails: ['payment_request'], staff: false },
  payment_refund: { emails: ['refund_issued'], staff: false },
  photo_email_sent_internal: { emails: ['photos'], staff: false },
  abandon_cart: { emails: ['abandoned_cart'], staff: false },
}

// Same wording as the Simple Emails list (AutomatedEmails.vue getType).
export const SIMPLE_EMAIL_LABELS = {
  confirmation: 'Booking confirmation',
  updated_booking: 'Updated booking',
  cancelled_booking: 'Cancelled booking',
  cancelled_transaction: 'Cancelled transaction',
  gift_card_confirmation: 'Gift card purchase confirmation',
  payment_request: 'Payment request',
  refund_issued: 'Refund issued',
  photos: 'Photos',
  abandoned_cart: 'Abandoned cart',
}

// What an automation on this trigger replaces, or null when it replaces nothing.
export function replacedByTrigger(triggerKey) {
  const entry = AUTOMATION_REPLACES_SIMPLE_EMAILS[triggerKey]
  if (!entry) return null
  return {
    emails: entry.emails,
    labels: entry.emails.map(type => SIMPLE_EMAIL_LABELS[type] || type),
    staff: entry.staff,
  }
}

// Active automations that take the place of the given simple email type.
// Expects rows shaped like the email-automations list ({ id, name, is_active,
// trigger_type: { key } }). includesStaff is true when any of them also
// replaces the staff copy.
export function automationsReplacing(emailType, automations) {
  const matches = (automations || []).filter(automation => {
    if (automation.is_active !== true) return false
    const entry = AUTOMATION_REPLACES_SIMPLE_EMAILS[automation.trigger_type?.key]
    return !!entry && entry.emails.includes(emailType)
  })
  return {
    automations: matches,
    includesStaff: matches.some(a => AUTOMATION_REPLACES_SIMPLE_EMAILS[a.trigger_type.key].staff),
  }
}
